import React from "react";
import { slide as Menu } from "react-burger-menu";
import styles from "./sidebar.module.css";
const SidebarC = ({comp, ...props}) => {
 
 
  return <Menu  crossButtonClassName={styles.crossButtonClassName} {...props}>
          {comp}
        </Menu>
    
  
};

export default React.memo(SidebarC);
